const MESSAGES = {
  FIRST_START: "Начни игру!", // При первом запуске страницы

} as const;

export default MESSAGES;